module.exports = __webpack_public_path__ + "static/media/GPartner.ba2bbfb3.jpg";